import { Outlet } from 'react-router-dom';

import { AppLayout } from 'components/navigation/AppLayout';

export const WatchlistLayout = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};
